export interface ConektaIframeConfig {
  options: any;
  config: IframeConfig;
  callbacks: ConektaIframeCallbacks;
  conektaSource?: string;
  isIntegration?: boolean;
}

interface IframeConfig {
  locale: string;
  targetIFrame: string;
  allowTokenization: true;
  checkoutRequestId: string; // checkout request id
  publicKey: string;
}

interface ConektaIframeCallbacks {
  onCreateTokenSucceeded: Function;
  onCreateTokenError: Function;
  onFinalizePayment: Function;
  onErrorPayment: Function;
  onGetInfoSuccess: Function;
  onHeightChange: Function;
}

export enum ConektaSource {
  EMBEDDED = 'checkout-embedded',
  TOKENIZER = 'token-card-form',
  PAYMENT_LINK = 'payment-link',
  REDIRECTED = 'checkout-redirect',
  COMPONENT = 'component',
  COMPONENT_TOKENIZER = 'component-tokenizer',
}

export const xSource = 'x-source';
